import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import randID from '../../../utilities/randID'
import styled from 'styled-components'
import { Link, NavLink } from "react-router-dom"
import { _logOut } from '../../../container/redux/services/user.service';


const StyledNavigation = styled.div`
    min-width: 250px;
    position: absolute;
    right: -5px;
    top: 60px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 9999999;
    border-radius: 10px 0px 10px 10px;
    border-radius: var(--soft-shadow);
    transition: .5s;
    box-shadow: 0px 10px 30px rgba(0,0,0,.08);
    animation: bulge .25s ease-out;
    @keyframes bulge{
        from{
            top: 80px;
            opacity: 0;
        }
        to{
            top: 60px;
            opacity: 1;
        }
    }

    @media(min-width: 768px){
        right: 25px;
    }
`
const Nav = styled.nav`
    flex-direction: column;  
    background: #111;
    border-radius: 5px;
    width: 100%;
    color: #fff;
    padding-top: 20px;
    & button.green{
        margin-left: 5px !important
    }
   

    & > * {
        padding: 12px 20px 12px 30px;
    }    
    & a {
        display: flex;
        text-transform: capitalize;
    }
    & a i {
        margin: 0px 30px 0px 0px !important;
    }
    & > a * {
        color: #aaa;
    }
    & a:hover > * {
        color: #fff
    }
    & .quick-btn{
        border-top: 1px solid #555;
        padding: 10px 5px 0px 5px !important;
    }
    @media(max-width: 768px){
        &::after{
            content: "";
            position: absolute;
            height: 30px;
            width: 30px;
            background: #111111;
            top: -3px;
            left: 80%;
            transform: translateX(-50%);
            transform: rotate(45deg);
            border-right: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            z-index: -1;
        }
    }
`


const Navigation = ({isOpen, closeNav, state})=>{

    const dispatch = useDispatch()
    const NavLinks = [
        {title: 'Home', route: ' ', icon: 'home' },
        {title: 'Upload photos', route: 'upload', icon: 'backup' },
        {title: 'Friends', route: '@theo', },
        {title: 'Friends', route: '@erons', },
        {title: 'Friends', route: '@frontend_io', },
        {title: 'Friends', route: '@theosdsd', },
    ]
    const handleEvent  = ()=>{
        dispatch(_logOut())
        closeNav()
    }




    
    return(
        <React.Fragment>
            {
                isOpen &&
                <StyledNavigation>
                    <Nav>
                        {
                            NavLinks.map(link=>{
                                const {  title, route } = link
                                return(
                                    <NavLink 
                                        onClick={closeNav} 
                                        to={`/${route}`} 
                                        key={randID()}
                                    >
                                        <span>{title}</span>
                                    </NavLink>
                                )
                            })
                        }   
                        <ul  className='grid equal no-padding quick-btn'>
                            {
                                !state ? 
                                <>
                                    <Link to='/login'>
                                        <button onClick={closeNav} className='full-width green'>Login</button>
                                    </Link>
                                    <Link to='/join'>
                                        <button onClick={closeNav} className='full-width red'>Join</button>
                                    </Link>
                                </>
                                : 
                                <button onClick={handleEvent} className='full-width red'>Sign out</button>
                            }
                        </ul> 
                    </Nav>
                </StyledNavigation>
            }
        </React.Fragment>
    )
}


export default Navigation